var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJar2(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 367 535",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M295.94 134.83H68.39l-44.43 88.1a42.165 42.165 0 00-5.14 20.16v197.32c0 42.19 34.2 76.39 76.39 76.39h176.36c42.19 0 76.39-34.2 76.39-76.39V243.33c0-7.19-1.84-14.27-5.35-20.55l-46.66-87.95h-.01z",
    fill: "#EEF9FA",
    stroke: "#CDE2E4",
    strokeWidth: 32,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M254.04 9.08h-147c-39.682 0-71.85 32.168-71.85 71.85v25.47c0 39.682 32.168 71.85 71.85 71.85h147c39.682 0 71.85-32.168 71.85-71.85V80.93c0-39.682-32.168-71.85-71.85-71.85z",
    fill: "#FD934F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M265.13 3.79H93.51c-32.883 0-59.54 26.655-59.54 59.535 0 32.88 26.657 59.535 59.54 59.535h171.62c32.883 0 59.54-26.655 59.54-59.535 0-32.88-26.657-59.535-59.54-59.535z",
    fill: "#FED425"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M301.23 425.35H65.54c-25.808 0-46.73 20.922-46.73 46.73 0 25.808 20.922 46.73 46.73 46.73h235.69c25.808 0 46.73-20.922 46.73-46.73 0-25.808-20.922-46.73-46.73-46.73z",
    fill: "#EEF9FA",
    stroke: "#CDE2E4",
    strokeWidth: 27.47,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M223.97 53.82h-80.35c-7.097 0-12.85 5.753-12.85 12.85v1.44c0 7.097 5.753 12.85 12.85 12.85h80.35c7.097 0 12.85-5.753 12.85-12.85v-1.44c0-7.097-5.753-12.85-12.85-12.85z",
    fill: "#2A848E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M278.16 412.76H89.43c-16.105 0-29.16 13.055-29.16 29.16v15.82c0 16.104 13.055 29.16 29.16 29.16h188.73c16.105 0 29.16-13.056 29.16-29.16v-15.82c0-16.105-13.055-29.16-29.16-29.16z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M146.34 359.98v83.94c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9v-82.76l-76.39-1.17-.01-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M184.54 376.32c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M222.74 381.83c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M222.74 412.24c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.92 359.98v83.94c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9v-82.76l-76.39-1.17-.01-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.12 376.32c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M142.31 381.83c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M142.31 412.24c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M222.74 359.98v83.94c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9v-82.76l-76.39-1.17-.01-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M260.94 376.32c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M299.13 381.83c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M299.13 412.24c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M292.36 267.73v-24.4c0-7.19-1.84-14.27-5.35-20.55l-9-16.97M292.36 396.67v-81.34",
    stroke: "#FBFDFE",
    strokeWidth: 21,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M144.75 475.35c21.097 0 38.2-17.103 38.2-38.2s-17.103-38.2-38.2-38.2-38.2 17.103-38.2 38.2 17.103 38.2 38.2 38.2z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 15.85,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJar2);
export default ForwardRef;